import { Module } from 'vuex';
import { JobState } from './types';
import { actions } from './actions';

const job: Module<JobState, any> = {
  namespaced: true,
  actions,
};

export default job;
